<div *ngIf="featuredReview"
  class="block w-full relative"
  [ngStyle]="{
    'padding': linePadding,
    'background-color': backgroundColor
  }"
>
  <div class="max-w-6xl mx-auto">
  <div>
    <vsf-title-box
      [titleInfo]="titleInfo"
      [forComponent]="true">
    </vsf-title-box>
  </div>
  <ng-template [ngIf]="(isMobile===false)">
    <div class="customer-reviews flex flex-row">
        <div class="customer-say">
            <div>
                <p class="text-[24px] font-bold">Customer say</p>
            </div>
            <div class="quote-container">
              <div class="quote-left-container">
                <fa-icon icon="quote-left" class="quote-left"></fa-icon>
              </div>
              <p class="customer-say-content" [title]="customerSay">{{ customerSay }}</p>
              <div class="quote-right-container">
                <fa-icon icon="quote-right" class="quote-right"></fa-icon>
              </div>
            </div>
            <div>
                <small>A featured review from our customer.</small>
            </div>
        </div>
        <div class="z-8 nav-button">
          <fa-icon
            icon="chevron-left"
            class="cursor-pointer left-button p-2"
            (click)="swipeToPrev()">
          </fa-icon>
        </div>
        <div class="rounded-lg relative w-full">
          <!-- Browser mode: Show Swiper -->
          <div class="px-1"
            [ngStyle]="{
              'max-width': reviewListWidth+'px',
              'min-width': reviewListWidth+'px',
            }"
            *ngIf="slidesPerView > 0 && isBrowser; else desktopFallbackList">
            <swiper-container
              appSwiper
              #desktopReviewSwiper
              [slidesPerView]="slidesPerView"
              [spaceBetween]="20"
              [rewind]="true">
              <swiper-slide *ngFor="let review of reviews; let i = index" class="swiper-slide h-full">
                <div class="review-card px-4 py-2 border border-[#E7E9ED] rounded flex flex-col h-full">
                  <div class="flex flex-row items-start items-center">
                    <div *ngIf="displayReviewAssets && (review.featuredAsset?.imageUrl || review.featuredAsset?.preview)">
                      <img
                          class="w-12 h-12 rounded-full object-cover mb-2 mr-2"
                          [src]="review.featuredAsset | assetPreview:'small':'webp'"
                          alt="{{ review.name || 'Anonymous' }} avatar"
                      />
                    </div>
                    <p class="font-bold">{{ review.name ? review.name : 'Anonymous' }}</p>
                  </div>
                  <vsf-product-review-indicator
                    class="mb-2"
                    [inputScore]="review.rating"
                    [displayReviewNumbers]="false">
                  </vsf-product-review-indicator>
                  <p class="font-bold review-summary" [title]="review.summary">{{ review.summary }}</p>
                  <p #reviewContent [overflowCheck]="i" class="mt-1 review-content" [title]="review.content">
                    {{ review.content }}
                  </p>
                  <span *ngIf="overflow[i]" (click)="openReviewDialog(review)" class="more-link">more</span>
                </div>
              </swiper-slide>
            </swiper-container>
          </div>
        </div>
        <div class="z-8 nav-button">
          <fa-icon
            icon="chevron-right"
            class="cursor-pointer right-button p-2"
            (click)="swipeToNext()">
          </fa-icon>
        </div>
    </div>
  </ng-template>

  <ng-template [ngIf]="isMobile">
    <div class="customer-reviews flex flex-col">
      <div class="customer-say">
          <div>
              <p>Customer say</p>
          </div>
          <div class="quote-container">
            <div class="quote-left-container">
              <fa-icon icon="quote-left" class="quote-left"></fa-icon>
            </div>
            <p class="customer-say-content" [title]="customerSay">{{ customerSay }}</p>
            <div class="quote-right-container">
              <fa-icon icon="quote-right" class="quote-right"></fa-icon>
            </div>
          </div>
          <div>
              <small>A featured review from our customer.</small>
          </div>
      </div>
      <!-- Browser mode: Show Swiper; otherwise fallback -->
      <ng-container *ngIf="isBrowser; else mobileFallbackList">
        <div class="w-100">
        <swiper-container appSwiper #mobileReviewSwiper
                          [slidesPerView]="1.5" [spaceBetween]="20"
                          rewind="true"
                          class="flex-grow">
            <swiper-slide *ngFor="let review of reviews; let i = index" class="swiper-slide h-full">
              <div class="review-card px-4 py-2 shadow border border-[#E7E9ED] rounded flex flex-col h-full">
                <div class="flex flex-row items-start items-center">
                  <div *ngIf="displayReviewAssets && (review.featuredAsset?.imageUrl || review.featuredAsset?.preview)">
                    <img
                        class="w-12 h-12 rounded-full object-cover mb-2 mr-2"
                        [src]="review.featuredAsset | assetPreview:'small':'webp'"
                        alt="{{ review.authorName || 'Anonymous' }} avatar"
                    />
                  </div>
                  <p class="font-bold">{{ review.name ? review.name : 'Anonymous' }}</p>
                </div>
                <vsf-product-review-indicator
                  class="mb-2"
                  [inputScore]="review.rating"
                  [displayReviewNumbers]="false">
                </vsf-product-review-indicator>
                <p class="font-bold review-summary" [title]="review.summary">{{ review.summary }}</p>
                <p #reviewContent [overflowCheck]="i" class="mt-1 review-content" [title]="review.content">
                  {{ review.content }}
                </p>
                <span *ngIf="overflow[i]" (click)="openReviewDialog(review)" class="more-link">more</span>
              </div>
            </swiper-slide>
        </swiper-container>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <!-- Desktop Fallback (SSR) for when isBrowser = false -->
  <ng-template #desktopFallbackList>
    <div class="reviews-list px-1">
      <div class="flex flex-col items-center justify-center h-full">
        <div class="review-card px-4 py-2 border border-[#E7E9ED] rounded flex flex-col h-full">
          <!-- Display only the first review if available -->
          <ng-container *ngIf="reviews && reviews.length > 0; else noReview">
            <p class="font-bold">{{ reviews[0].name ? reviews[0].name : 'Dealomega Customer' }}</p>
            <vsf-product-review-indicator
              class="mb-2"
              [inputScore]="reviews[0].rating"
              [displayReviewNumbers]="false">
            </vsf-product-review-indicator>
            <p class="font-bold review-summary" [title]="reviews[0].summary">{{ reviews[0].summary }}</p>
            <p class="mt-1 review-content" [title]="reviews[0].content">
              {{ reviews[0].content }}
            </p>
          </ng-container>
          <ng-template #noReview>
            <p>No Reviews Found</p>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Mobile Fallback (SSR) for when isBrowser = false -->
  <ng-template #mobileFallbackList>
    <div class="flex flex-col items-center justify-center h-full">
      <div class="review-card px-4 py-2 shadow border border-[#E7E9ED] rounded flex flex-col h-full">
        <!-- Display only the first review if available -->
        <ng-container *ngIf="reviews && reviews.length > 0; else noMobileReview">
          <p class="font-bold">{{ reviews[0].name ? reviews[0].name : 'Dealomega Customer' }}</p>
          <vsf-product-review-indicator
            class="mb-2"
            [inputScore]="reviews[0].rating"
            [displayReviewNumbers]="false">
          </vsf-product-review-indicator>
          <p class="font-bold review-summary" [title]="reviews[0].summary">{{ reviews[0].summary }}</p>
          <p class="mt-1 review-content" [title]="reviews[0].content">
            {{ reviews[0].content }}
          </p>
        </ng-container>
        <ng-template #noMobileReview>
          <p>No Reviews Found</p>
        </ng-template>
      </div>
    </div>
  </ng-template>
  </div>
</div>
